import { render, staticRenderFns } from "./OrderStatuses.vue?vue&type=template&id=518ff7b2&scoped=true&"
import script from "./OrderStatuses.vue?vue&type=script&lang=js&"
export * from "./OrderStatuses.vue?vue&type=script&lang=js&"
import style0 from "./OrderStatuses.vue?vue&type=style&index=0&id=518ff7b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "518ff7b2",
  null
  
)

export default component.exports